import React, { useRef } from 'react';

const Password = () => {
    const currentUsernameRef = useRef("");
    const currentPasswordRef = useRef("");
    
    const onSubmit = event => {
        event.preventDefault();

        if (currentUsernameRef.current.value.match(/^(?=.*[a-z])|(?=.*[A-Z])$/) ) {
            alert("matched");
        } else {
            alert("not matched");
        }
    }

    return (
        <div className="center-admin">
            <form className="form-admin d-flex flex-column p-5 bg-dark" onSubmit={onSubmit}>
                    <input ref={currentUsernameRef} type="text" placeholder="New username" />
                    <input ref={currentPasswordRef} type="password" placeholder="New password" />
                    <input className="btn btn-info" type="submit" value="SUBMIT" />
                </form>
        </div>
    );
};

export default Password;